import { UserActivityContainer, UserInfoAndTimelineContainer } from 'custom_modules/FieldServices/RouteMapNew/routeMapStyles';
import { CommImageNameComp } from 'custom_modules/Members/CommonComponents';
import moment from 'moment';
import { CommonText } from 'styledComponents/common';
import avatar5 from 'assets/img/avatar_5.svg';
import AttendanceTimelineElement from './AttendanceTimelineElement';
import { LoadingIndicator } from 'components/ReactSelectPaginatedDropdown/DropdownIndicator';
import { useTranslation } from 'react-i18next';
const AttendanceTimeline = ({
  attendance,
  selectedEmployee,
  geofenceData = [],
  isLoading = false
}) => {
  const { t } = useTranslation();
  // Process geofence data into timeline events
  const processGeofenceData = () => {
    const timelineEvents = [];
    timelineEvents.push({
      id: `clock-in-${attendance.id}`,
      event: 'clock_in',
      timestamp: attendance.clockin_timestamp,
      lat: attendance.clockin_lat,
      long: attendance.clockin_long,
    });

    // Add geofence events
    geofenceData.forEach((geofence, index) => {
      timelineEvents.push({
        id: `geofence-in-${geofence.id}`,
        event: 'checkin',
        timestamp: geofence.geofence_in_timestamp,
        lat: geofence.geofence_in_lat,
        long: geofence.geofence_in_long,
        last: false
      });

      timelineEvents.push({
        id: `geofence-out-${geofence.id}`,
        event: 'checkout',
        timestamp: geofence.geofence_out_timestamp,
        lat: geofence.geofence_out_lat,
        long: geofence.geofence_out_long,
        last: false
      });
    });

    timelineEvents.push({
      id: `clock-out-${attendance.id}`,
      event: 'clock_out',
      timestamp: attendance.clockout_timestamp,
      lat: attendance.clockout_lat,
      long: attendance.clockout_long,
    });

    return timelineEvents;
  };

  const calculateTimeSpent = (timelineEvents) => {
    if (!timelineEvents || timelineEvents.length === 0) {
      return {
        inside: { hours: 0, minutes: 0 },
        outside: { hours: 0, minutes: 0 },
        totalTime: { hours: 0, minutes: 0 },
        isOngoing: false,
        status: 'unknown'
      };
    }

    const currentMoment = moment();

    // Step 1: Validate and parse timestamps
    const validTimeline = timelineEvents
      .map(event => {
        let parsedTime;

        if (typeof event.timestamp === 'number') {
          parsedTime = moment.unix(event.timestamp);
        } else {
          parsedTime = moment(event.timestamp, "YYYY-MM-DD HH:mm:ss", true);
        }

        if (!parsedTime.isValid() || parsedTime.isAfter(currentMoment)) {
          console.warn(`Invalid timestamp detected!`, { event: event.event, timestamp: event.timestamp });
          return null;
        }

        return {
          ...event,
          parsedTimestamp: parsedTime
        };
      })
      .filter(event => event !== null);

    if (validTimeline.length === 0) {
      return {
        inside: { hours: 0, minutes: 0 },
        outside: { hours: 0, minutes: 0 },
        totalTime: { hours: 0, minutes: 0 },
        isOngoing: false,
        status: 'unknown'
      };
    }

    const sortedTimeline = [...validTimeline].sort((a, b) => a.parsedTimestamp.valueOf() - b.parsedTimestamp.valueOf());

    let totalTimeInside = 0;
    let totalTimeOutside = 0;
    let totalTimeWorked = 0;

    let working = false;
    let inside = false;
    let lastTimestamp = null;

    let previousEvent = null;  // to track previous event and avoid double-counting

    // Step 2: Loop through events
    sortedTimeline.forEach(event => {
      if (!lastTimestamp) {
        lastTimestamp = event.parsedTimestamp;
      }

      const duration = moment.duration(event.parsedTimestamp.diff(lastTimestamp)).asMilliseconds();

      // Avoid adding time for repeated check-ins without checkouts
      if (working) {
        if (inside) {
          totalTimeInside += duration;
        } else {
          totalTimeOutside += duration;
        }
      }

      // Handle event type changes
      if (event.event === 'clock_in') {
        if (previousEvent && previousEvent.event === 'clock_in') {
          // Avoid starting new session if clock_in is repeated without clock_out
          return;
        }
        working = true;
        inside = false;
      } else if (event.event === 'clock_out') {
        working = false;
      } else if (event.event === 'checkin') {
        if (!inside) {
          inside = true; // start inside session
        }
      } else if (event.event === 'checkout') {
        if (inside) {
          inside = false; // end inside session
        }
      }

      lastTimestamp = event.parsedTimestamp;
      previousEvent = event;  // store current event as previous for next iteration
    });

    // Step 3: Handle ongoing work
    if (working && lastTimestamp) {
      const duration = moment.duration(currentMoment.diff(lastTimestamp)).asMilliseconds();
      if (inside) {
        totalTimeInside += duration;
      } else {
        totalTimeOutside += duration;
      }
    }

    const clockInEvent = validTimeline.find(event => event.event === 'clock_in');
    const clockOutEvent = validTimeline.find(event => event.event === 'clock_out');

    if (clockInEvent) {
      if (clockOutEvent) {
        totalTimeWorked = moment.duration(clockOutEvent.parsedTimestamp.diff(clockInEvent.parsedTimestamp)).asMilliseconds();
      } else {
        totalTimeWorked = moment.duration(currentMoment.diff(clockInEvent.parsedTimestamp)).asMilliseconds();
      }
    }

    // Convert milliseconds to hours and minutes
    const msToTime = (durationMs) => {
      const minutes = Math.floor(durationMs / (1000 * 60));
      const hours = Math.floor(minutes / 60);
      return {
        hours,
        minutes: minutes % 60
      };
    };

    // if in the event list there is no checkin and checkout event, then consider the whole time as inside
    if (!validTimeline.find(event => event.event === 'checkin') && !validTimeline.find(event => event.event === 'checkout')) {
      totalTimeInside = totalTimeWorked;
      totalTimeOutside = 0;
    }

    return {
      totalTimeWorked: msToTime(totalTimeWorked),
      inside: msToTime(totalTimeInside),
      outside: msToTime(totalTimeOutside),
      totalTime: msToTime(totalTimeInside + totalTimeOutside),
      isOngoing: working,
      status: working ? 'working' : 'ended'
    };
  };





  const timelineEvents = processGeofenceData();
  const filteredTimelineEvents = timelineEvents.filter(event => event.timestamp !== 0);
  const timeSpent = calculateTimeSpent(filteredTimelineEvents);


  console.log('🚀 ~ timelineEvents:', filteredTimelineEvents);
  console.log('🚀 ~ timeSpent:', timeSpent);

  if (isLoading) {
    return (
      <UserInfoAndTimelineContainer>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '300px' }}>
          <LoadingIndicator />
        </div>
      </UserInfoAndTimelineContainer>
    );
  }

  return (
    <UserInfoAndTimelineContainer>
      <UserActivityContainer>
        {selectedEmployee?.id ? (
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'space-between', alignItems: 'center' }}>
            <CommImageNameComp
              imgSource={selectedEmployee?.avatar || avatar5}
              name={selectedEmployee?.first_name + ' ' + selectedEmployee?.last_name}
              size="60px"
            />
            <span style={{ fontSize: '12px', fontWeight: 'bold', color: timeSpent.status === 'working' ? 'green' : 'red' }}>
              {timeSpent.status === 'working' ? 'In Progress' : 'Ended'}
            </span>
          </div>
        ) : null}

        <CommonText>
          {moment(attendance?.date).format('dddd, DD MMMM, YYYY')}
        </CommonText>

        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '10px' }}>
          <CommonText style={{ fontWeight: 'bold', display: 'flex', gap: '4px' }}>
            <span dir="auto">{t('Inside')}</span>
            <span dir="ltr">{timeSpent.inside.hours} h {timeSpent.inside.minutes} m</span>
          </CommonText>
          <CommonText style={{ fontWeight: 'bold', display: 'flex', gap: '4px' }}>
            <span dir="auto">{t('Outside')}</span>
            <span dir="ltr">{timeSpent.outside.hours} h {timeSpent.outside.minutes} m</span>
          </CommonText>
        </div>
      </UserActivityContainer>

      {timelineEvents.map((event, index) => (
        <AttendanceTimelineElement
          key={event.id}
          {...event}
          last={index === timelineEvents.length - 1}
          hideCreatedBy={true}
        />
      ))}
    </UserInfoAndTimelineContainer>
  );
};

export default AttendanceTimeline;
